import {observable, computed} from 'mobx';

export class Parameters {
  constructor(searchResults) {
    this.searchResults = searchResults;
  }

  @computed get criteria() {
    let criteria = [];
    for(let item of this.searchResults.items) {
      for(let parameter of item.parameters) {
        if(parameter.value === null) {
          continue;
        }
        let ccrit;
        ccrit = criteria.find(o => o.name === parameter.name);
        if(!ccrit) {
          ccrit = {
            name: parameter.name,
            typeName: parameter.typeName,
          }
          switch(parameter.typeName) {
            case 'Enum':
              ccrit.items = [];
              break;
            case 'String':
              ccrit.items = [];
              break;
            case 'Integer':
              ccrit.min = undefined;
              ccrit.max = undefined;
              break;
            case 'Float':
              ccrit.min = undefined;
              ccrit.max = undefined;
              break;
            case 'Boolean':
              ccrit.items = [];
              break;           
          }          
          criteria.push(ccrit);
        }
        switch(parameter.typeName) {
          case 'Enum':
            if(!ccrit.items.find(o => o === parameter.value)) {
              ccrit.items.push(parameter.value);
            }
            break;
          case 'String':
            if(!ccrit.items.find(o => o === parameter.value)) {
              ccrit.items.push(parameter.value);
            }
            break;
          case 'Integer':
            ccrit.min = ccrit.min !== undefined ? Math.min(ccrit.min, parameter.value) : parameter.value;
            ccrit.max = ccrit.max !== undefined ? Math.max(ccrit.max, parameter.value) : parameter.value;
            break;
          case 'Float':
            ccrit.min = ccrit.min !== undefined ? Math.min(ccrit.min, parameter.value) : parameter.value;
            ccrit.max = ccrit.max !== undefined ? Math.max(ccrit.max, parameter.value) : parameter.value;
            break;
          case 'Boolean':
            if(!ccrit.items.find(o => o === parameter.value)) {
              ccrit.items.push(parameter.value);
            }
            break;           
        }          

      }      
    }
    return criteria.filter(o => {
      return (o.items && o.items.length > 1) ||
      (o.min !== o.max)
    });
  }
}


// WEBPACK FOOTER //
// ./src/aggregate/Parameters.js